var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-container"},[_c('div',{staticClass:"left-info"},[_c('TitleShow'),_c('ActionBtns')],1),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-maps"},[_c('img',{attrs:{"src":require("@/assets/images/playDetails/setupAccount/banner_map.png"),"alt":""}})])
}]

export { render, staticRenderFns }